<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Gestión de Valorados</h5>
          <div class="row mb-3">
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Oficina: </label>
                  <select 
                    v-model="filters.oficina" 
                    class="form-select"
                  >
                    <option value="">Todos</option>  
                    <option value="dde">DDE-Beni</option>
                    <option value="minedu">Minedu</option>
                  </select>
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('valorado_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round me-2"
              >
                <i class="fa fa-plus me-1"></i> Nuevo Valorado
              </BButton>
              <BButton
                v-if="hasPermission('valorado_create')"
                variant="danger"
                class="btn-round"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered">
                <thead class="text-primary">
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th>Codigo</th>
                    <th>Descripcion Valorado</th>
                    <th>Costo BS.</th>
                    <th>Oficina</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="valorado in valorados" :key="valorado.id">
                    <td>{{ valorado.codigo }}</td>
                    <td>{{ valorado.descripcion }}</td>
                    <td>{{ valorado.costo }}</td>
                    <td>{{ valorado.oficina }}</td>
                    <td>
                      <BBadge :variant="valorado.estado === 'activo' ? 'success' : 'danger'">
                        {{ valorado.estado }}
                      </BBadge>
                    </td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          v-if="hasPermission('valorado_update')"
                          @click="showModal(valorado)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <BButton
                          v-if="hasPermission('valorado_delete')"
                          @click="confirmDelete(valorado)"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Descripcion del Valorado</label>
              <input
                type="text"
                v-model="form.descripcion"
                class="form-control"
                :class="{ 'is-invalid': errors.descripcion }"
                required
              />
              <div class="invalid-feedback" v-if="errors.descripcion">
                {{ errors.descripcion[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Costo</label>
              <input
                type="text"
                v-model="form.costo"
                class="form-control"
                :class="{ 'is-invalid': errors.costo }"
                required
              />
              <div class="invalid-feedback" v-if="errors.costo">
                {{ errors.costo[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Oficina: </label>
              <select 
                v-model="form.oficina" 
                class="form-select"
              >
                <option value="DDE">DDE-Beni</option>
                <option value="MINEDU">Minedu</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Item</label>
              <select
                v-model="form.id_item"
                class="form-select"
                :class="{ 'is-invalid': errors.id_item }"
                required
              >
                <option value="">Seleccione</option>
                <option 
                  v-for="item in items" 
                  :key="item.id" 
                  :value="item.id"
                >
                  {{ item.codigo }} - {{ item.nombre_item }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.id_item">
                {{ errors.id_item[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Estado</label>
              <select
                v-model="form.estado"
                class="form-select"
                :class="{ 'is-invalid': errors.estado }"
                required
              >
                <option value="activo">Activo</option>
                <option value="inactivo">Inactivo</option>
              </select>
              <div class="invalid-feedback" v-if="errors.estado">
                {{ errors.estado[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Valorado {
  id: number;
  costo: string;
  descripcion: string;
  estado: string;
  oficina: string;
}

interface FormData {
  id: number | null;
  id_item: string;
  costo: string;
  descripcion: string;
  estado: string;
  oficina: string;
}

interface Filters {
  oficina: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const valorados = ref<Valorado[]>([]);
    const loading = ref(true);
    const authStore = useAuthStore();
    const items = ref<Item[]>([]);
    const loadingItems = ref(true);

    const filters = ref<Filters>({
      oficina: 'DDE'
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});

    const form = ref<FormData>({
      id: null,
      id_item: '',
      costo: '',
      descripcion: '',
      estado: 'activo',
      oficina: 'DDE',
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Editar Valorado' : 'Nuevo Valorado';
    });

    const showModal = (valorado: Valorado | null) => {
      errors.value = {};
      if (valorado) {
        // Edición
        isEditing.value = true;
        form.value = {
          id: valorado.id,
          id_item: valorado.id_item,
          costo: valorado.costo,
          descripcion: valorado.descripcion,
          estado: valorado.estado,
          oficina: valorado.oficina,
        };
      } else {
        // Nuevo
        isEditing.value = false;
        form.value = {
          id: null,
          id_item: '',
          costo: '',
          descripcion: '',
          estado: 'activo',
          oficina: 'DDE'
        };
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      try {
        let response;
        
        if (isEditing.value && form.value.id) {
          response = await axios.post(`/valorado/update/${form.value.id}`, form.value);
        } else {
          response = await axios.post('/valorado/save', form.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        modalVisible.value = false;
        fetchValorado();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const fetchItems = async () => {
      try {
        const response = await axios.get('/compras/items/list');
        items.value = response.data.data;
      } catch (error) {
        console.error('Error al cargar items:', error);
      }
    };

    const fetchValorado = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        
        if (filters.value.oficina) {
          params.oficina = filters.value.oficina;
        }
        
        const response = await axios.get('/valorado/list', { params });
        valorados.value = response.data.valorados.data || response.data.valorados;
        
        // Actualizar paginación si la API la soporta
        if (response.data.valorados.meta) {
          pagination.value = {
            current_page: response.data.valorados.meta.current_page,
            per_page: response.data.valorados.meta.per_page,
            total: response.data.valorados.meta.total,
            last_page: response.data.valorados.meta.last_page
          };
        }
        
      } catch (error) {
        console.error('Error al cargar valorados:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los valorados'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchValorado();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchValorado();
    };
    
    const confirmDelete = (valorado: Valorado) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la sección ${valorado.descripcion}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteValorado(valorado.id);
        }
      });
    };
    
    const deleteValorado = async (id: number) => {
      try {
        await axios.delete(`/valorado/delete/${id}`);
        Swal.fire({
          icon: 'success',
          title: 'Sección eliminada',
          text: 'La sección ha sido eliminada correctamente'
        });
        await fetchValorado();
      } catch (error: any) {
        console.error('Error al eliminar sección:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar la sección'
        });
      }
    };

    const generatePDF = () => {
      // Lógica para generar PDF
      const params = filters.value.oficina ? { oficina: filters.value.oficina } : {};
      
      axios.get('/valorado/reporte', {
        params,
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-valorados.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchValorado();
      fetchItems();
    });
    
    return {
      valorados,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      items,
      loadingItems,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
</style>